import {
  Bone,
  Brain,
  Baby,
  Clock,
  Stethoscope,
  Wind,
  Utensils,
  Activity,
  Waves
} from "lucide-react"
import React from "react"
import arvind from './assets/team1.png'
import test1 from './assets/test1.png'
import test2 from './assets/test2.png'
import test3 from './assets/test3.png'
import musculo from './assets/Musculo Skeletal Institute.png'
import neurology from './assets/Neuro Science.png'
import child from './assets/Women & Child Care_2.png'
import geriatrics from './assets/Geriatrics Institute.png'
import head from './assets/Head & Neck Institute.png'
import pulmonology from './assets/pulmonologist-respiratory-system.png'
import gas from './assets/Gastroenterology Institute.png'
import endocrine from './assets/endocrinology.png'
import nephrology from './assets/Nephrology Institute.png'


export const VCNR_PURPLE = "#6941e6"

export const INSTITUTES = [
  {
    id: "musculo-skeletal",
    name: "VCNR Musculo Skeletal Institute",
    description:
      "Comprehensive care for bone, joint, and muscle disorders including advanced surgery and rehabilitation.",
    image: musculo,
    icon: "Bone",
    services: [
      "Orthopedics",
      "Rheumatology",
      "Advanced Centre for Pain Management",
      "Integrated Rehabilitation",
      "Ergonomics Clinic",
      "Sports Medicine Clinic"
    ]
  },
  {
    id: "neuro-science",
    name: "VCNR Neuro Science Institute",
    description:
      "Expert treatment for neurological disorders, deaddiction, and sleep-related issues.",
    image:  neurology,
    icon: "Brain",
    services: [
      "Neurology Mind Care Clinic",
      "Deaddiction Centre",
      "Sleep Disorders Clinic",
      "Integrated Neurological Rehabilitation"
    ]
  },
  {
    id: "women-child",
    name: "VCNR Women & Child Care Institute",
    description:
      "Specialized healthcare from fertility and obstetrics to pediatric and child development care.",
    image:
      child,
    icon: "Baby",
    services: [
      "Obstetrics",
      "Gynecology",
      "Pediatrics",
      "Fertility Clinic",
      "Child Development Centre"
    ]
  },
  {
    id: "geriatrics",
    name: "VCNR Geriatrics Institute",
    description:
      "Dedicated to the health and wellness of the elderly through healthy aging and home care.",
    image:
      geriatrics,
    icon: "Clock",
    services: [
      "Rejuvenation Clinic",
      "Healthy Ageing Clinic",
      "Integrated Rehabilitation",
      "Home Care"
    ]
  },
  {
    id: "head-neck",
    name: "VCNR Head & Neck Institute",
    description:
      "Integrated care for ENT, Dental, Eye, Skin, Hearing, and Speech disorders.",
    image:
      head,
    icon: "Stethoscope",
    services: [
      "Ear, Nose & Throat Care",
      "Dental Care",
      "Eye Care",
      "Skin Care",
      "Hearing & Speech Care",
      "Swallowing Care"
    ]
  },
  {
    id: "pulmonology",
    name: "VCNR Pulmonology Institute",
    description:
      "Advanced respiratory care for allergy, asthma, and complex sleep-related breathing disorders.",
    image:
      pulmonology,
    icon: "Wind",
    services: ["Allergy Clinic", "Asthma Care", "Respiratory & Sleep Clinic"]
  },
  {
    id: "gastroenterology",
    name: "VCNR Gastroenterology Institute",
    description:
      "Expert management of digestive health, obesity, and clinical nutrition.",
    image:
      gas,
    icon: "Utensils",
    services: [
      "Digestive Care Centre",
      "Piles & Fistula Clinic",
      "Obesity Clinic",
      "Diet & Nutrition"
    ]
  },
  {
    id: "endocrinology",
    name: "VCNR Endocrinology Institute",
    description:
      "Focused care for diabetes, thyroid, and lifestyle-related endocrine conditions.",
    image:
      endocrine,
    icon: "Activity",
    services: [
      "Diabetes Clinic",
      "Thyroid Clinic",
      "Wellness Clinic",
      "Lifestyle Clinic"
    ]
  },
  {
    id: "nephrology",
    name: "VCNR Nephrology Institute",
    description:
      "Comprehensive kidney care and urological services with precision and compassion.",
    image:
     nephrology,
    icon: "Waves",
    services: ["Nephrology", "Urology"]
  }
]

export const DOCTORS = [
  {
    id: 1,
    name: "Dr. Vinay",
    specialty: "Orthopedic Surgeon",
    institute: "VCNR Musculo Skeletal Institute",
    exp: "15+ Years",
    image:     arvind
  },
  {
    id: 2,
    name: "Dr. Vinay",
    specialty: "Neurologist",
    institute: "VCNR Neuro Science Institute",
    exp: "12+ Years",
    image:     arvind
  },
  {
    id: 3,
    name: "Dr. Vinay",
    specialty: "Pediatrician",
    institute: "VCNR Women & Child Care Institute",
    exp: "20+ Years",
   image:     arvind
  },
  {
    id: 4,
    name: "Dr. Vinay",
    specialty: "Endocrinologist",
    institute: "VCNR Endocrinology Institute",
    exp: "10+ Years",
   image:     arvind
  }
]

export const HEALTH_PACKAGES = [
  {
    id: "h1",
    name: "Executive Health Checkup",
    price: "₹4,999",
    duration: "4 Hours",
    benefits: [
      "Full Blood Profile",
      "Cardiac Stress Test",
      "Ultrasound Scans",
      "Doctor Consultation"
    ]
  },
  {
    id: "h2",
    name: "Senior Citizen Wellness",
    price: "₹3,499",
    duration: "3 Hours",
    benefits: [
      "Bone Density Test",
      "Vision/Hearing Screen",
      "Diabetes Profile",
      "Dietary Consultation"
    ]
  },
  {
    id: "h3",
    name: "Women's Wellness Pro",
    price: "₹3,999",
    duration: "4 Hours",
    benefits: [
      "Mammography",
      "Thyroid Profile",
      "Vitamin D Check",
      "Gynae Consultation"
    ]
  }
]

// Added TESTIMONIALS export to fix the build error in Home.tsx
export const TESTIMONIALS = [
  {
    id: 1,
    name: "Arjun Mehta",
    role: "Patient - Orthopedics",
    content:
      "The care I received at the Musculo Skeletal Institute was life-changing. From advanced surgery to rehabilitation, the team was exceptional.",
    avatar:
      test1
  },
  {
    id: 2,
    name: "Sneha Reddy",
    role: "Mother - Pediatrics",
    content:
      "VCNR Women & Child Care provided a safe and comforting environment for my child's treatment. Their child development centre is world-class.",
    avatar:
      test2
  },
  {
    id: 3,
    name: "Robert D'Souza",
    role: "Patient - Geriatrics",
    content:
      "The healthy ageing clinic at VCNR has helped me maintain my mobility and independence. Truly the best geriatric care in Bangalore.",
    avatar:
      test3
  }
]

export const getIcon = name => {
  switch (name) {
    case "Bone":
      return <Bone size={24} />
    case "Brain":
      return <Brain size={24} />
    case "Baby":
      return <Baby size={24} />
    case "Clock":
      return <Clock size={24} />
    case "Stethoscope":
      return <Stethoscope size={24} />
    case "Wind":
      return <Wind size={24} />
    case "Utensils":
      return <Utensils size={24} />
    case "Activity":
      return <Activity size={24} />
    case "Waves":
      return <Waves size={24} />
    default:
      return <Stethoscope size={24} />
  }
}
